import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import GuestRoute from '../components/GuestRoute';
import { routeConfig } from './config';

export const AppRoutes = routeConfig.map((route, index) => {
  if (route.guestOnly) {
    return (
      <Route key={index} path={route.path} element={
        <GuestRoute key={route.path} allowIncompleteAccount={route.allowIncompleteAccount}>
          {route.protected ? (
            <ProtectedRoute requireCompleteAccount={route.requireCompleteAccount}>
              {route.element}
            </ProtectedRoute>
          ) : route.element}
        </GuestRoute>
      } />
    );
  }
  if (route.protected) {
    return (
      <Route
        key={index}
        path={route.path}
        element={
          <ProtectedRoute requireCompleteAccount={route.requireCompleteAccount}>
            {route.element}
          </ProtectedRoute>
        }
      />
    );
  }
  return (
    <Route
      key={index}
      path={route.path}
      element={route.element}
    />
  );
});
